export enum Language {
  English = "en",
  Dutch = "nl",
  German = "de"
}